import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=ae880aa2&"
import script from "./LangSwitcher.vue?vue&type=script&lang=ts&"
export * from "./LangSwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae880aa2')) {
      api.createRecord('ae880aa2', component.options)
    } else {
      api.reload('ae880aa2', component.options)
    }
    module.hot.accept("./LangSwitcher.vue?vue&type=template&id=ae880aa2&", function () {
      api.rerender('ae880aa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LangSwitcher/LangSwitcher.vue"
export default component.exports